import React from "react";
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Rating from '@mui/material/Rating';


const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'hidden',
    padding:'0',
    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px !important',
  },
  image: {
    width: '100%',
    minHeight:'300px ',
    borderRadius: '5%',
    transition: 'transform 0.3s ease-in-out',
  },
}));

const MyCard = ({ title, content }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent sx={{padding:'10%', paddingBottom:'10% !important',borderRadius: '5%'}}>
        <Grid>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Grid container direction='row' justifyContent='space-between'>
                        <Grid item md={3}>
                            <img src="https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg" alt="client" style={{width:'60px',height:'60px',borderRadius:'50px'}} />
                        </Grid>
                        <Grid item md={8}>
                            <Grid container direction="column" justifyContent='center'>
                                <Grid item>
                                    <Typography variant="subtitle1" fontWeight='bold'>Appartments</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle2">4 listings</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle1" >The WP Estate team delivered on that expectation and I would highly recommend them to anyone who is in the market to buy.</Typography>
                </Grid>
                <Grid item>
                    <Rating name="read-only" value='5' readOnly />
                </Grid>
            </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

const Testimonials = () => {
  const cards = [
    { title: 'Card 1', content: 'Content 1' },
    { title: 'Card 2', content: 'Content 2' },
    { title: 'Card 3', content: 'Content 3' },
    { title: 'Card 4', content: 'Content 4' },

  ];

  return (
    <>
        <Grid sx={{padding:'40px 0'}}>
            <Typography variant="h4">Clients Testimonials</Typography>
        </Grid>
        <Grid container spacing={4}>
        {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
                <MyCard title={card.title} content={card.content} />
            </Grid>
        ))}
        </Grid>
    </>
  );
}

export default Testimonials
